import { useContext, useLayoutEffect, useState } from "react";
import CustomizerContext from "../../../../../_helper/Customizer";
import {
  ExpenseClass,
  Description,
  ClassName,
  ExpenseGroup,
  whtApply,
  vatApply,
  Status,
} from "../../../../../Constant";
import useAuth from "../../../../../Hooks/useAuth";
import { createDropdownField } from "../../../../../Data/FormField/PublicData";
import {
  financesExpenseCategoryApi,
  financesExpenseClassApi,
  financesExpenseGroupApi,
} from "../../../../../api";
import useAxiosPrivate from "../../../../../Hooks/useAxiosPrivate";
import { toast } from "react-toastify";

export default function useExpenseClassController() {
  const axiosPrivate = useAxiosPrivate();
  const formTitle = ExpenseClass;
  const { userOrganisationId }: any = useAuth();
  const [formFields, setFormFields] = useState<any[]>([
    {
      id: "name",
      name: "name",
      label: ClassName,
      type: "text",
      value: "",
      required: true,
      colSize: 6,
    },

    {
      id: "description",
      name: "description",
      label: Description,
      type: "textarea",
      value: "",
      required: true,
      colSize: 6,
    },
    {
      id: "is_active",
      name: "is_active",
      label: Status,
      type: "switch",
      value: "",
      colSize: 6,
    },
    {
      id: "is_vat_apply", 
      name: "is_vat_apply",
      label: vatApply,
      type: "switch",
      value: "",
      colSize: 6,
    },
    {
      id: "is_wht_apply",
      name: "is_wht_apply",
      label: whtApply,
      type: "switch",
      value: "",
      colSize: 6,
    },
  ]);

  const expenseCategory = createDropdownField(
    axiosPrivate,
    "expense_category",
    "expense_category",
    ExpenseGroup,
    `${financesExpenseCategoryApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}`,
    "",
    6
  );
  expenseCategory.onChange = async (id, updatedFields) => {
    const nextField = updatedFields.find(
        (field: any) => field.id === "expense_group"
    );
    if (nextField) {
        const endPoint = `${financesExpenseGroupApi}?organisation_id=${userOrganisationId}&expense_category_id=${id}`
        await nextField.fetchOptions(id, false, endPoint);
        const updatedFormFields = updatedFields.map((field: any) => {
            if (field.id === "expense_category") {
                return { ...field, value: id };
            }
            return field;
        });
        setFormFields([...updatedFormFields]);
    }
  };

  const expenseGroup = createDropdownField(
    axiosPrivate,
    "expense_group",
    "expense_group",
    ExpenseClass,
    `${financesExpenseGroupApi}?skip=${0}&limit=${10}&with_trashed=${false}&organisation_id=${userOrganisationId}&expense_group_id=1`,
    "",
    6
  );

  // ?? Call on every dependent change
  async function updateFields() {
    const updatedFields = [expenseCategory, expenseGroup, ...formFields];
    await expenseCategory.fetchOptions();
    setFormFields(updatedFields);
  }

  useLayoutEffect(() => {
    //?? Updates all fields once component is mounted
    updateFields();
  }, []);

  const { layoutURL } = useContext(CustomizerContext);
  const backBtn = `${process.env.PUBLIC_URL}/finance/settings/expense-class/${layoutURL}`;

  async function onSubmit(data: any) {
    //?? pass the expense group id dynamically
    let expense_group_id = Number(data.expense_group);

    data.expense_group_id = expense_group_id;
    await axiosPrivate
        .post(financesExpenseClassApi, data)
        .then((_res) => {
          toast.success(`${_res.data.name} Created Successfully.`)
        })
        .catch((err) => {
            if (err.response && err.response.status === 422) {
            toast.error('Validation Errors');
            } else if (err.response && err.response.status === 400) {
            toast.error(err.response.data.detail);
            } else {
            toast.error('Something Went Wrong');
            }
            throw err;
        });
 
  }

  return { formTitle, formFields, backBtn, onSubmit };
}
